var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictoSaidaActivoDevice(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons/32x32/saida") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/32x32/saida",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    fillOpacity: 0,
    fill: "#D8D8D8",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(1.500000, 3.000000)",
    stroke: "#00A9FD",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.3076923,26.965812 C26.3076923,27.4944948 25.8944167,27.9230769 25.3846154,27.9230769 L18.9230769,27.9230769 C18.4132756,27.9230769 18,27.4944948 18,26.965812 L18,15.957265 C18,15.4285821 18.4132756,15 18.9230769,15 L25.3846154,15 C25.8944167,15 26.3076923,15.4285821 26.3076923,15.957265",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2683618,24.2307692 L30,21.4805539 M27.2683618,18.6923077 L29.9192314,21.3959374 M21.9312814,21.5358248 L29.5784414,21.5358248",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,18 C2.8954305,18 2,17.1045695 2,16 L2,2 C2,0.8954305 2.8954305,0 4,0 L26,0 C27.1045695,0 28,0.8954305 28,2 L28,12.019043",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0710449,15 L6,15 C5.44771525,15 5,14.5522847 5,14 L5,4 C5,3.44771525 5.44771525,3 6,3 L24,3 C24.5522847,3 25,3.44771525 25,4 L25,12.1708984",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,19 L12,19 C11.4477153,19 11,18.5522847 11,18 L0,18 L0,19",
    id: "Path",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0710449,22 C12.0393841,22 7.49189298,22 1.42857143,22 C0.639593215,22 0,21.1045695 0,20 L0,18",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoSaidaActivoDevice);
export default __webpack_public_path__ + "static/media/PictoSaidaActivoDevice.141aa292b75912259164780777961415.svg";
export { ForwardRef as ReactComponent };